module.exports = __webpack_public_path__ + "4a23fd8a8c717cc842dac2cd903c8bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_pdf_light.png
// module id = 882
// module chunks = 0 1